// IE 2026 10 22 / ODOO-5800 (замечания Igor 22.10 по бою, блок «Where the rule was searched» формы ячейки: «цифры с количеством найденных карт … кликабельными …
// попадать в список правил (например „Правила переміщень“)», «при клике по кнопке решения … ожидал увидеть виджет списка с сегментом основные склады»):
// чистая логика ССЫЛОК-ВИДЖЕТОВ блока — без Vue и DOM. Бэк (common_modules/rule_lookup_diag.py) отдаёт в lookup: rules_widget {widget, title} — списочный виджет
// сегмента карты (MAP-Distr → «Transfer Rules» …), rule_ids у клеток лесенки и rules_with_value_ids у измерений (≤ 50), solution_link / link решения / list карточек
// «Fix here, in WebSCM» — {kind: 'widget', widget, title, chip: {field, label, value, title}} (список «Основной склад для стран» с чипсом страны получателя).
// Здесь они превращаются в открываемую ссылку {kind: 'widget', widget, title, where, chipTitle}; Dropdown.linkOpen открывает список через store.cellRulesList_open
// с чипсом CHIP-Where в памяти вкладки (meta._cellRules — в стол и запись списка не сохраняется, как список правил ячейки и Гант узла).
import { t, tn } from '@/i18n'

export const LOOKUP_MAIN_WH_LEVERS = ['ship_from_main_warehouse', 'set_main_warehouse', 'receive_to_main_warehouse']   // решения, чьё действие — запись в «Основной склад для стран»

export function lookup_isWidgetLink(l) { return !!(l && typeof l === 'object' && l.kind === 'widget' && l.widget) }

function whereEq(field, label, value, title) {
    return { use: true, leftValue: { value: String(field), valueStr: String(label || field) }, condition: '=', rightValue: { value: String(value), valueStr: String(title || value) } }
}
function whereIn(field, label, items) {
    return { use: true, leftValue: { value: String(field), valueStr: String(label || field) }, condition: 'in', rightValue: { value: '', valueStr: '' },
        attrs: items.map(([id, title]) => ({ use: true, rightValue: { value: String(id), valueStr: String(title || id) } })) }
}

// ссылка-виджет бэка → открываемая: чипс «<label>: <title>» по строке chip (field = value); без chip — список без отбора. Не ссылка-виджет — null
export function lookup_widgetLink(l) {
    if (!lookup_isWidgetLink(l)) return null
    const where = []
    let chipTitle = String(l.title || l.widget)
    const c = l.chip && typeof l.chip === 'object' ? l.chip : null
    if (c && c.field && c.value) { where.push(whereEq(c.field, c.label || c.field, c.value, c.title)); chipTitle = String(c.label || c.field) + ': ' + String(c.title || c.value) }
    return { kind: 'widget', widget: String(l.widget), title: String(l.title || l.widget), where, chipTitle }
}

// клик по числу лесенки («Rules found» N) или колонки «Rules with this value»: список правил сегмента карты с чипсом «Rule in [ids]»;
// known — краткие карты подмножества (≤ 5, {id, title}) для подписей значений чипса; label — контекст подписи чипса (узел · подмножество). Списка / id нет — null
export function lookup_rulesLink(lk, ids, label, known) {
    const w = lk && typeof lk === 'object' && lk.rules_widget && typeof lk.rules_widget === 'object' ? lk.rules_widget : null
    if (!w || !w.widget || !Array.isArray(ids) || !ids.length) return null
    const titleOf = {}
    for (const r of Array.isArray(known) ? known : []) if (r && r.id) titleOf[String(r.id)] = String(r.title || r.id)
    const items = ids.filter(Boolean).map(id => [String(id), titleOf[String(id)] || String(id)])
    if (!items.length) return null
    const what = items.length === 1 ? items[0][1] : tn(items.length, '{n} rule', '{n} rules')
    return { kind: 'widget', widget: String(w.widget), title: String(w.title || w.widget), where: [whereIn('id', t('Rule'), items)], chipTitle: (label ? String(label) + ': ' : '') + what }
}

// ссылка решения блока: своя ссылка-виджет бэка, иначе — общая solution_link lookup для решений про основной склад (бэк старее / решение достроено позже)
export function lookup_solutionLink(sol, lk) {
    const own = lookup_widgetLink(sol && sol.link)
    if (own) return own
    const lever = String((sol && sol.lever) || '')
    return LOOKUP_MAIN_WH_LEVERS.includes(lever) ? lookup_widgetLink(lk && lk.solution_link) : null
}
